import ServicosCnaeGruposService from "@/services/ServicosCnaeGruposService";

export const servicosCnaeGrupos = {
  namespaced: true,
  state: {
    servicosCnaeGrupos: {},
  },
  actions: {
    getServicosCnaeGrupos({ commit }, payload) {
      return ServicosCnaeGruposService.GetServicosCnaeGrupos(payload).then(
        (servicosCnaeGrupos) => {
          return Promise.resolve(servicosCnaeGrupos);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postServicosCnaeGrupos({ commit }, payload) {
      return ServicosCnaeGruposService.PostServicosCnaeGrupos(payload).then(
        (servicosCnaeGrupos) => {
          return Promise.resolve(servicosCnaeGrupos);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putServicosCnaeGrupos({ commit }, payload) {
      return ServicosCnaeGruposService.PutServicosCnaeGrupos(payload).then(
        (servicosCnaeGrupos) => {
          return Promise.resolve(servicosCnaeGrupos);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteServicosCnaeGrupos({ commit }, payload) {
      return ServicosCnaeGruposService.DeleteServicosCnaeGrupos(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getServicosCnaeGruposOData({ commit }, payload) {
      return ServicosCnaeGruposService.GetServicosCnaeGruposOData(payload).then(
        (servicosCnaeGrupos) => {
          return Promise.resolve(servicosCnaeGrupos);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default servicosCnaeGrupos;
